import { getSize } from '../iterable/getSize';

export function startsWithAlphanumeric(value) {
  return /^[\p{L}\p{Nd}]/u.test(value);
}

export function usedMoreThanAllowed({ patterns, number, value }) {
  function reducePatterns(invalid, pattern) {
    return invalid || getSize(value.match(new RegExp(pattern, 'gu'))) > number;
  }

  return patterns.reduce(reducePatterns, false);
}
